import { Field, Form, Formik } from 'formik';
import { InputType } from '../../../Common/FormFields/InputType';
import { Typography } from '@material-ui/core';
import Box from '@mui/material/Box';
import RoundButton from '../../../Common/RoundButton';
import moment from 'moment';
import ErrorMessage from '../../../Common/ErrorMessage';
import { DropDown } from '../../../Common/FormFields/DropDown';
import { useState } from 'react';
import { ERROR_MESSAGE_TRUE } from '../../../utils/placeHolderString';

export default function PersonalForm({
  initialValues,
  validationSchema,
  onSubmitHandle,
  onChangeField,
  error,
  genderData,
  inputType,
  handleOnFocus,
  firstNameAccess,
  lastNameAccess,
  panNumberAccess,
  emailAccess,
  dobAccess,
  addressAccess,
  pinCodeAccess,
  genderAccess,
  aadharNumberAccess,
  enterKeyPress,
  formikRef,
  fatherNameAccess
}: any) {
  const [message, setMessage] = useState<string>('');
  const accessed = () => {
    setMessage(ERROR_MESSAGE_TRUE);
  };
  const NotAccessible = () => {};
  return (
    <>
      {/* <Typography className="text-info">
        Your mobile number is now verified. We will need some more personal
        details before we move forward, these KYC details are important before
        you start investing.
      </Typography> */}
      <div style={{ marginBottom: '10px' }}>
        <Box>
          <Formik
            validateOnMount={true}
            innerRef={formikRef}
            enableReinitialize={true}
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(value) => onSubmitHandle(value)}
          >
            {({ handleSubmit, values, touched, errors }) => (
              <Form>
                {message !== '' && <ErrorMessage text={message} />}
                <div>
                  <Field
                    component={InputType}
                    type='text'
                    placeholder='first name'
                    name='firstName'
                    value={values?.firstName}
                    onKeyPress={enterKeyPress}
                    onChange={onChangeField}
                    readOnly={firstNameAccess}
                    className={
                      firstNameAccess === true
                        ? 'readOnly'
                        : 'withIcon inputUser'
                    }
                    onClick={
                      firstNameAccess === true
                        ? () => accessed()
                        : () => NotAccessible()
                    }
                  />
                  <Field
                    component={InputType}
                    type='text'
                    placeholder='last name'
                    name='lastName'
                    value={values?.lastName}
                    onChange={onChangeField}
                    readOnly={lastNameAccess}
                    className={
                      lastNameAccess === true
                        ? 'readOnly'
                        : 'withIcon inputUser'
                    }
                    onClick={
                      lastNameAccess === true
                        ? () => accessed()
                        : () => NotAccessible()
                    }
                    onKeyPress={enterKeyPress}
                  />
                  <Field
                    component={InputType}
                    type='text'
                    placeholder="father's name"
                    name='father_name'
                    value={values?.father_name}
                    onChange={onChangeField}
                    readOnly={fatherNameAccess}
                    className={
                      fatherNameAccess === true
                        ? 'readOnly'
                        : 'withIcon inputUser'
                    }
                    onClick={
                      fatherNameAccess === true
                        ? () => accessed()
                        : () => NotAccessible()
                    }
                    onKeyPress={enterKeyPress}
                  />
                  <Field
                    component={InputType}
                    type='number'
                    placeholder='aadhaar number'
                    name='adharnumber'
                    value={values?.adharnumber}
                    onChange={onChangeField}
                    maxLength={12}
                    // readOnly={readOnly}
                    readOnly={aadharNumberAccess}
                    className={
                      aadharNumberAccess === true
                        ? 'readOnly'
                        : 'withIcon inputAadhar'
                    }
                    onClick={
                      aadharNumberAccess === true
                        ? () => accessed()
                        : () => NotAccessible()
                    }
                    onKeyPress={enterKeyPress}
                  />
                  <Field
                    component={InputType}
                    type='text'
                    placeholder='PAN card number'
                    name='panNumber'
                    value={values?.panNumber?.toUpperCase()}
                    onChange={onChangeField}
                    maxLength={10}
                    readOnly={panNumberAccess}
                    className={
                      panNumberAccess === true
                        ? 'readOnly'
                        : 'withIcon inputAadhar'
                    }
                    onClick={
                      panNumberAccess === true
                        ? () => accessed()
                        : () => NotAccessible()
                    }
                    onKeyPress={enterKeyPress}
                  />
                  <Field
                    component={InputType}
                    type='text'
                    placeholder='personal email id'
                    name='email'
                    value={values?.email}
                    onChange={onChangeField}
                    maxLength={50}
                    readOnly={emailAccess}
                    className={
                      emailAccess === true ? 'readOnly' : 'withIcon inputEmail'
                    }
                    onClick={
                      emailAccess === true
                        ? () => accessed()
                        : () => NotAccessible()
                    }
                    onKeyPress={enterKeyPress}
                  />
                  <Field
                    component={InputType}
                    type={inputType}
                    placeholder='DOB'
                    name='dob'
                    value={values?.dob}
                    onChange={onChangeField}
                    max={moment(new Date()).format('YYYY-MM-DD')}
                    onFocus={handleOnFocus}
                    readOnly={dobAccess}
                    className={
                      dobAccess === true ? 'readOnly' : 'withIcon inputDob'
                    }
                    onClick={
                      dobAccess === true
                        ? () => accessed()
                        : () => NotAccessible()
                    }
                    onKeyPress={enterKeyPress}
                  />
                  <span
                    className={
                      genderAccess === true
                        ? 'readOnly inputSelectGender'
                        : 'inputSelectGender'
                    }
                  >
                    <Field
                      component={DropDown}
                      type='text'
                      placeholder='gender'
                      name='gender'
                      value={values?.gender}
                      onChange={onChangeField}
                      Data={genderData}
                      readOnly={genderAccess}
                      className={genderAccess === true ? 'readOnly' : ''}
                      onClick={
                        genderAccess === true
                          ? () => accessed()
                          : () => NotAccessible()
                      }
                      onKeyPress={enterKeyPress}
                    />
                  </span>
                  {/* <Field
                    component={InputType}
                    placeholder='address 1'
                    name='address'
                    value={values?.address}
                    onChange={onChangeField}
                    readOnly={addressAccess}
                    className={
                      addressAccess === true
                        ? 'readOnly'
                        : 'withIcon inputAddress'
                    }
                    onClick={
                      addressAccess === true
                        ? () => accessed()
                        : () => NotAccessible()
                    }
                    onKeyPress={enterKeyPress}
                  />
                  <Field
                    component={InputType}
                    placeholder='pin code'
                    name='pincode'
                    type='number'
                    value={values?.pincode}
                    onChange={onChangeField}
                    maxLength={6}
                    readOnly={pinCodeAccess}
                    className={
                      pinCodeAccess === true
                        ? 'readOnly'
                        : 'withIcon inputPincode'
                    }
                    onClick={
                      pinCodeAccess === true
                        ? () => accessed()
                        : () => NotAccessible()
                    }
                    onKeyPress={enterKeyPress}
                  /> */}
                </div>
                {error && <ErrorMessage text={error} />}
                <Box sx={{ mt: 4 }}>
                  <RoundButton title='Continue' type='submit' />
                </Box>
              </Form>
            )}
          </Formik>
        </Box>
      </div>
    </>
  );
}
